import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { SelectOptionType } from '../utils/Types';

interface IMSelectProps {
  label: string;
  value?: string | number | null;
  disabled?: boolean;
  options?: SelectOptionType[];
  onChange?: (value: any) => void;
  required?: boolean;
  labelClassName?: string | null;
  hideLabel?: boolean;
  dataTestId?: string;
}

const MSelect: React.FunctionComponent<IMSelectProps> = ({
  label,
  value,
  disabled,
  onChange,
  options,
  required,
  labelClassName,
  hideLabel,
  dataTestId,
}) => {
  const ITEM_HEIGHT = 58;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      },
    },
  };
  return (
    <FormControl fullWidth className="text-field">
      {!hideLabel && (
        <InputLabel
          id="react-simple-select-label"
          variant="standard"
          shrink={!!value}
        >
          {required ? (
            <span>
              {label}
              <span className="text-danger"> *</span>
            </span>
          ) : (
            label
          )}
        </InputLabel>
      )}
      <Select
        labelId="react-m-select"
        id="demo-simple-select"
        value={value ?? ''}
        onChange={onChange}
        variant="standard"
        disabled={disabled}
        required={required}
        sx={{ fontSize: '12px' }}
        inputProps={{ style: { fontSize: '12px' } }}
        className={labelClassName ?? ''}
        MenuProps={MenuProps}
        data-testid={
          dataTestId && dataTestId?.length > 0 ? dataTestId : `test-id-${label}`
        }
      >
        {options?.map((item, index) => (
          <MenuItem
            key={`menu-${String(index)}`}
            value={item.value}
            sx={{ fontSize: '14px' }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MSelect;
